
export enum KindOfAttentionDay {
    AttentionDay = 1,
    Holiday = 2,
}

export interface IAttentionDay {
    id: number | null;
    name: string;
    start: Date;
    end: Date;
    kind: KindOfAttentionDay;
}
